import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import "containers/Spotlight/MySpotlight.css";
import "components/Spotlight/Spotlight_Common.css";
import "containers/ProjectCommon.css";
import "./PrivateUserProfile.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
import CoverBanner from "components/Spotlight/CoverBanner";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import FriendUserProfileBox from "components/Tribe/Friends/UserDetail/FriendUserProfileBox";
import TextTheme from "components/General/Text/TextTheme";
import ProfileDetailTabs from "components/Tribe/Friends/UserDetail/ProfileDetailTabs";
import FriendNewsfeed from "components/Tribe/Friends/UserDetail/FriendNewsfeed/FriendNewsfeed";
import FriendMotivationalBanner from "components/Tribe/Friends/UserDetail/FriendMotivationalBanner";
import FriendListContainer from "components/Tribe/Friends/FriendsHome/FriendListContainer";
import GroupListContainer from "components/Tribe/Groups/GroupsHome/GroupListContainer";

/*Group helper method to delete a group invite*/
import * as GroupInvite from "components/Tribe/Groups/GroupHelperMethods";
import { Fragment } from "react";

class FriendUserProfileDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      friendSlug: props.friendSlug,
      full_name:props.full_name,
      type: props.type,
      cover_pic: this.props.friendCoverPic || MyDefaultCoverPhoto,
      currentToggle: 1,
      hasSentGroupRequest: "",
      currentFriendPage: 1,
    };
    /*function bindings*/
    this.setToggleClick = this.setToggleClick.bind(this);
    this.renderGroupInviteBanner = this.renderGroupInviteBanner.bind(this);
  }

  componentDidMount() {
    // if this page will render the group invite motivational banner, check whether this user
    // has already sent a group request.
    if (this.props.type === CONSTANT.GROUP_INVITE_URL) {
      this.fetchAlreadySentGroupRequest(this);
    }
  }

  // check if this user has already sent a group request.
  fetchAlreadySentGroupRequest(obj) {
    AxiosConfig.get(
      `groups/invitations/${this.state.friendSlug}/${this.props.groupName}/`
    )
      .then(function (response) {
        obj.setState({ hasSentGroupRequest: true });
      })
      .catch(function (response) {
        obj.setState({ hasSentGroupRequest: false });
      });
  }
  /*Used to change the current page on the friends list*/
  handleFriendPageChange(page) {
    this.setState({ currentFriendPage: page });
  }
  /**
   * Used to set the new current toggle.
   */
  setToggleClick(toggleIndex) {
    /*Toggle index 1 is About Me*/
    if (toggleIndex === 1) {
      this.setState((prevState) => ({
        currentToggle: 1,
      }));
    } else if (toggleIndex === 2) {
      /*Toggle index 1 is News*/
      this.setState((prevState) => ({
        currentToggle: 2,
      }));
    } else if (toggleIndex === 3) {
      /*Toggle index 1 is Impact*/
      this.setState((prevState) => ({
        currentToggle: 3,
      }));
    } else if (toggleIndex === 4) {
      /*Toggle index 1 is Tribe*/
      this.setState((prevState) => ({
        currentToggle: 4,
      }));
    } else if (toggleIndex === 5) {
      /*Toggle index 1 is Album*/
      this.setState((prevState) => ({
        currentToggle: 5,
      }));
    }
  }

  renderProfileTabToggle() {
    /*Toggle index 1 is About Me*/
    if (this.state.currentToggle === 1) {
      return (
        <div>
          <ProfileDetailTabs
            firstButtonIsActive="true"
            secondButtonIsActive="false"
            thirdButtonIsActive="false"
            fourthButtonIsActive="false"
            fifthButtonIsActive="false"
            firstButtonText={CONSTANT.ABOUT_ME}
            secondButtonText={CONSTANT.NEWS}
            thirdButtonText={CONSTANT.IMPACT}
            fourthButtonText={CONSTANT.TRIBE}
            fifthButtonText={CONSTANT.ALBUM}
            firstButtonClick={() => this.setToggleClick(1)}
            secondButtonClick={() => this.setToggleClick(2)}
            thirdButtonClick={() => this.setToggleClick(3)}
            fourthButtonClick={() => this.setToggleClick(4)}
            fifthButtonClick={() => this.setToggleClick(5)}
          />
        </div>
      );
    } else if (this.state.currentToggle === 2) {
      /*Toggle index 1 is News*/
      return (
        <div>
          <ProfileDetailTabs
            firstButtonIsActive="false"
            secondButtonIsActive="true"
            thirdButtonIsActive="false"
            fourthButtonIsActive="false"
            fifthButtonIsActive="false"
            firstButtonText={CONSTANT.ABOUT_ME}
            secondButtonText={CONSTANT.NEWS}
            thirdButtonText={CONSTANT.IMPACT}
            fourthButtonText={CONSTANT.TRIBE}
            fifthButtonText={CONSTANT.ALBUM}
            firstButtonClick={() => this.setToggleClick(1)}
            secondButtonClick={() => this.setToggleClick(2)}
            thirdButtonClick={() => this.setToggleClick(3)}
            fourthButtonClick={() => this.setToggleClick(4)}
            fifthButtonClick={() => this.setToggleClick(5)}
          />
        </div>
      );
    } else if (this.state.currentToggle === 3) {
      /*Toggle index 1 is Impact*/
      return (
        <div>
          <ProfileDetailTabs
            firstButtonIsActive="false"
            secondButtonIsActive="false"
            thirdButtonIsActive="true"
            fourthButtonIsActive="false"
            fifthButtonIsActive="false"
            firstButtonText={CONSTANT.ABOUT_ME}
            secondButtonText={CONSTANT.NEWS}
            thirdButtonText={CONSTANT.IMPACT}
            fourthButtonText={CONSTANT.TRIBE}
            fifthButtonText={CONSTANT.ALBUM}
            firstButtonClick={() => this.setToggleClick(1)}
            secondButtonClick={() => this.setToggleClick(2)}
            thirdButtonClick={() => this.setToggleClick(3)}
            fourthButtonClick={() => this.setToggleClick(4)}
            fifthButtonClick={() => this.setToggleClick(5)}
          />
        </div>
      );
    } else if (this.state.currentToggle === 4) {
      /*Toggle index 1 is Tribe*/
      return (
        <div>
          <ProfileDetailTabs
            firstButtonIsActive="false"
            secondButtonIsActive="false"
            thirdButtonIsActive="false"
            fourthButtonIsActive="true"
            fifthButtonIsActive="false"
            firstButtonText={CONSTANT.ABOUT_ME}
            secondButtonText={CONSTANT.NEWS}
            thirdButtonText={CONSTANT.IMPACT}
            fourthButtonText={CONSTANT.TRIBE}
            fifthButtonText={CONSTANT.ALBUM}
            firstButtonClick={() => this.setToggleClick(1)}
            secondButtonClick={() => this.setToggleClick(2)}
            thirdButtonClick={() => this.setToggleClick(3)}
            fourthButtonClick={() => this.setToggleClick(4)}
            fifthButtonClick={() => this.setToggleClick(5)}
          />
        </div>
      );
    } else if (this.state.currentToggle === 5) {
      /*Toggle index 1 is Album*/
      return (
        <div>
          <ProfileDetailTabs
            firstButtonIsActive="false"
            secondButtonIsActive="false"
            thirdButtonIsActive="false"
            fourthButtonIsActive="false"
            fifthButtonIsActive="true"
            firstButtonText={CONSTANT.ABOUT_ME}
            secondButtonText={CONSTANT.NEWS}
            thirdButtonText={CONSTANT.IMPACT}
            fourthButtonText={CONSTANT.TRIBE}
            fifthButtonText={CONSTANT.ALBUM}
            firstButtonClick={() => this.setToggleClick(1)}
            secondButtonClick={() => this.setToggleClick(2)}
            thirdButtonClick={() => this.setToggleClick(3)}
            fourthButtonClick={() => this.setToggleClick(4)}
            fifthButtonClick={() => this.setToggleClick(5)}
          />
        </div>
      );
    }
  }

  renderFriendTabContent() {
    /*Toggle index 1 is About Me*/
    if (this.state.currentToggle === 1) {
      return (
        <Fragment>
          <h4 className="aboutMeTitle">{CONSTANT.ABOUT_ME}</h4>
          <p>{this.props.about_me}</p>
          <h4 className="aboutMeTitle">{CONSTANT.MY_FAVORITE_THINGS}</h4>
          <p>{this.props.favorite_thing}</p>
          <h4 className="aboutMeTitle">{CONSTANT.MY_DREAM}</h4>
          <p>{this.props.dream}</p>
          <h4 className="aboutMeTitle">{CONSTANT.MY_HERO}</h4>
          <p>{this.props.heroes}</p>
          <h4 className="aboutMeTitle">{CONSTANT.MY_SUPERPOWERS}</h4>
          <p>{this.props.super_powers}</p>
          <h4 className="aboutMeTitle">{CONSTANT.I_SUPPORT}</h4>
          <ul>
            {this.props.project_interest &&
            this.props.project_interest.length > 0
              ? this.props.project_interest.map((elem, index) => (
                  <li key={index}>{elem}</li>
                ))
              : null}
          </ul>
          <h4 className="aboutMeTitle">{CONSTANT.FAVORITE_CAUSES}</h4>
          <p>{this.props.cause}</p>
        </Fragment>
      );
    } else if (this.state.currentToggle === 2) {
      /*Toggle index 1 is News*/
      return (
        <div className="d-flex">
          <FriendNewsfeed username={this.props.friendName} />
          <div className="add-feeds"></div>
        </div>
      );
    } else if (this.state.currentToggle === 3) {
      /*Toggle index 1 is Impact*/
      return (
        <TextTheme
          message={CONSTANT.IMPACT_SOON}
          className="text_medium text_med_grey text_bold text-center"
        />
      );
    } else if (this.state.currentToggle === 4) {
      /*Toggle index 1 is Tribe*/
      return (
        <Fragment>
          <div className="page_details_content_main friend-tribe">
            <TextTheme
              message="Friends"
              className="mb-15 text_medium text_dark_blue text_bold tribe-header"
            />
            {this.props.allFriends && this.props.allFriends.length > 0 ? (
              <FriendListContainer
                buttonTitle={CONSTANT.BUTTON_VIEW}
                friendLists={this.props.allFriends}
                type={CONSTANT.FRIENDS}
                currentFriendPage={this.state.currentFriendPage}
                handleFriendPageChange={this.handleFriendPageChange.bind(this)}
                isFriendTribe={true}
                userId={this.props.userId}
              />
            ) : null}
          </div>
          <div className="mt-15 page_details_content_main friend-tribe">
            <TextTheme
              message="Groups"
              className="mb-15 text_medium text_dark_blue text_bold tribe-header"
            />
            {this.props.allGroups && this.props.allGroups.length > 0 ? (
              <GroupListContainer
                groupLists={this.props.allGroups}
                type={CONSTANT.GROUPS}
                history={this.props.history}
                pageSize={5}
              />
            ) : null}
          </div>
        </Fragment>
      );
    } else if (this.state.currentToggle === 5) {
      /*Toggle index 1 is Album*/
      return (
        <TextTheme
          message={CONSTANT.ALBUM_SOON}
          className="text_medium text_med_grey text_bold text-center"
        />
      );
    }
  }

  /*render group member invite banner.*/
  renderGroupInviteBanner() {
    if (this.state.hasSentGroupRequest === true) {
      return (
        <FriendMotivationalBanner
          type={CONSTANT.GROUP_INVITE_URL}
          friendSlug={this.state.friendSlug}
          full_name={this.state.full_name}
          inviteOnClick={null}
          inviteDisabled={false}
          groupName={this.props.groupName}
        />
      );
    } else if (this.state.hasSentGroupRequest === false) {
      return (
        <FriendMotivationalBanner
          type={CONSTANT.GROUP_INVITE_URL}
          friendSlug={this.state.friendSlug}
          full_name={this.state.full_name}
          inviteOnClick={() =>
            GroupInvite.invite(this.state.friendSlug, this.props.groupID)
          }
          inviteDisabled={true}
          groupName={this.props.groupName}
        />
      );
    }
  }

  render() {

    return (
      <div className="header_main main_possible_friend">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>

          <div className="main_pane">
            <div className="cover_photo">
              <CoverBanner
                cover={this.state.cover_pic}
                profile={this.props.friendProfilePic}
              />
            </div>
            <div className="user_details">
              {this.props.type === CONSTANT.GROUP_INVITE_URL ? (
                this.renderGroupInviteBanner()
              ) : this.props.type === CONSTANT.GROUP_MEMBER_REVIEW_URL ||
                this.props.type === CONSTANT.GROUP_OWNER_REVIEW_URL ||
                this.props.type === CONSTANT.GROUP_MODERATOR_REVIEW_URL ? (
                <FriendMotivationalBanner
                  type={CONSTANT.GROUP_MEMBER_REVIEW_URL}
                  friendSlug={this.state.friendSlug}
                  full_name={this.state.full_name}
                  cancelOnClick={() =>
                    GroupInvite.deleteInvite(this.props.groupRequestId, {
                      history: this.props.history,
                      type: CONSTANT.GROUP_MEMBER_REVIEW_URL,
                      group_name: this.props.groupName,
                      group_id: this.props.groupID,
                    })
                  }
                  acceptOnClick={() =>
                    GroupInvite.acceptInvite(
                      this.props.friendName,
                      this.props.groupID
                    )
                  }
                />
              ) : this.props.type === CONSTANT.RECEIVED_REQUEST ? (
                <FriendMotivationalBanner
                  type={CONSTANT.RECEIVED_REQUEST}
                  friendSlug={this.state.friendSlug}
                  declineOnClick={() =>
                    GroupInvite.deleteInvite(this.props.groupRequestId, {
                      history: this.props.history,
                      type: CONSTANT.RECEIVED_REQUEST,
                      group_name: this.props.groupName,
                      group_id: this.props.groupID,
                    })
                  }
                  acceptOnClick={() =>
                    GroupInvite.acceptInvite(
                      this.state.friendSlug,
                      this.props.groupID,
                      {
                        history: this.props.history,
                        type: CONSTANT.RECEIVED_REQUEST,
                        group_name: this.props.groupName,
                        group_id: this.props.groupID,
                      }
                    )
                  }
                />
              ) : null}
              <FriendUserProfileBox
                username={this.props.friendName}
                age={this.props.friendAge}
                full_name={this.props.full_name}
                // location={this.props.friendLocation}
                location=""
                profilePic={this.props.friendProfilePic}
                type={CONSTANT.FRIENDS}
              />
              <div className="mb-15 profile_detail_tabs">
                {this.renderProfileTabToggle()}
              </div>
              <div className="mt-15 d-inline-block w-100">
                {this.renderFriendTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FriendUserProfileDetails;
